import axios from "axios";
import { URL } from "@/config.ts";

export default () => {
  return axios.create({
    baseURL: `${URL}/v1/front`,
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    }
  });
};
